export interface SaveOptions {
    includeId: boolean;
    onlyDirty: boolean;
}

export const DefaultSaveOptions: Readonly<SaveOptions> = { includeId: true, onlyDirty: false };
